import { DrupalNode, DrupalTaxonomyTerm } from 'next-drupal';
import {DrupalProductNode, ProductTypeTaxonomyTerm} from "@/types/hygiena-types";
import {createRef, useRef} from "react";
import {ProductTypeHero} from "../../organisms/hero/product-type-hero";
import dynamic from "next/dynamic";

const ContentProductType = dynamic(() => import("../../templates/taxonomy/content/content--product-type").then((mod) => mod.ContentProductType));

/**
 * The Product Type/Name page, filterable by Test Target.
 *
 * @param taxonomy_term
 * @param additionalContent
 * @constructor
 */
export function TaxonomyProductType ({
  taxonomy_term,
  additionalContent,
}: {
  taxonomy_term: ProductTypeTaxonomyTerm;
  additionalContent?: {
    subtypes: DrupalTaxonomyTerm[],
    products: DrupalProductNode[],
    complementaryProducts: DrupalProductNode[],
    childTerms: DrupalTaxonomyTerm[],
    relatedNews: DrupalNode[],
    relatedProducts?: DrupalProductNode[],
  };
}) {
  let products = additionalContent?.products ?? [];
  const solutionsRef = useRef<any>(null);
  const childTerms = additionalContent?.childTerms?.filter(item => item?.path?.alias);

  return (
    <>
      <ProductTypeHero taxonomy_term={taxonomy_term} scrollRef={(childTerms?.length || products?.length) ? solutionsRef : null}/>
      <ContentProductType taxonomy_term={taxonomy_term} additionalContent={additionalContent} solutionsRef={solutionsRef}/>
    </>
  );
}
